import React, { useState, useEffect, useCallback, useMemo } from "react";
import { FaUndo } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import img1 from "../../Assets/Images/img1.jpg";
import { RiSave2Fill } from "react-icons/ri";
import { IoExitOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Loader from "../../Shared_Components/Loader";
import axios from "axios";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { API_HOST } from "../../api_utils";
import {
  // Autocomplete,
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Modal,
  Pagination,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from "@mui/material";
import { TbArrowBackUp } from "react-icons/tb";
import { BsCameraFill } from "react-icons/bs";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { AutoComplete } from "antd";

function Customers(props) {
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const { userDataFromStorage, coloredTheme } = props;

  // states for filter
  // const [filterData, setFilterData] = useState([])
  const [customerNameContain, setCustomerNameContain] = useState("");
  const [customerStatus, setCustomerStatus] = useState("");
  const [customerNickname, setCustomerNickname] = useState("");

  const [currentData, setCurrentData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [openEditModalHandler, setOpenEditModalHandler] = useState(false);
  const [modalData, setModalData] = useState({
    customer_name: "",
    customer_id: "",
    photo: "",
    id_number: 0,
    mobile_number: "",
    phone_2: "",
    phone_3: "",
    phone_4: "",
    customer_number: "",
    nickname: "",
    agent_id: "",
    agent: "",
  });

  const [photo, setPhoto] = useState("");

  // loading and error states:
  const [imageLoading, setImageLoading] = useState(false);
  const [customerEditSuccess, setCustomerEditSuccess] = useState(false);
  const [nicknameModal, setNicknameModal] = useState(false);
  const [nicknameModalData, setNicknameModalData] = useState({});
  const [nicknameNew, setNicknameNew] = useState("");
  const [agentLinkedToNickname, setAgentLinkedToNickname] = useState("");

  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerNicknameList, setCustomerNicknameList] = useState([]);
  const [agentNameList, setAgentNameList] = useState([]);
  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const [selectedCustomerNickname, setSelectedCustomerNickname] = useState("");
  const [customerNameForApi, setCustomerNameForApi] = useState("");
  const [nicknameForApi, setNicknameForApi] = useState("");

  // STATES FOR NEW AUTO COMPLETE::::
  const [value, setValue] = useState("");
  const [options, setOptions] = useState([]);
  const [anotherOptions, setAnotherOptions] = useState([]);

  const [totalPages, setTotalPages] = useState(0);

  // GET CUSTOMER HEADER LIST:
  const getCustomerHeadApi = async () => {
    setLoading(true);
    const config = {
      "Content-Type": "application/json",
    };

    let apiUrl = `${API_HOST}/api/customer_head?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (customerNameForApi) {
      queryParams.push(`customer_name=${customerNameForApi}`);
    }
    if (customerStatus) {
      queryParams.push(`customer_status=${customerStatus}`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);

      setCurrentData(data);
    } else {
      setLoading(false);
    }
  };

  const getCustomerHeadApiCount = async () => {
    setLoading(true);
    const config = {
      "Content-Type": "application/json",
    };

    let apiUrl = `${API_HOST}/api/customer_head/count?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (customerNameForApi) {
      queryParams.push(`customer_name=${customerNameForApi}`);
    }
    if (customerStatus) {
      queryParams.push(`customer_status=${customerStatus}`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);

      setTotalPages(Math.ceil(data[0].totalCount / 20));
    } else {
      setLoading(false);
    }
  };

  const getAllAgentNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/agent_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setAgentNameList(data);
    } else {
      setLoading(false);
    }
  };

  const getAllCustomerList = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/customer_head/customer_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      // setCustomerHeadList(data)
      setCustomerOptions(data);
    } else {
      setLoading(false);
    }
  };

  const getAllCustomerNickname = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/customer/get_customer_nickname_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      // setCustomerHeadList(data)
      setCustomerNicknameList(data);
    } else {
      setLoading(false);
    }
  };

  const getUsersListHandler = async () => {
    setLoading(true);
    const { userDataFromStorage } = props;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    const { data } = await axios.get(`${API_HOST}/api/users/`, config);
    if (data) {
      if (data.message) {
        setLoading(false);
        toast.error(data.message);
      } else {
        setLoading(false);
        setUsersList(data);
      }
    }
  };

  const getCustomerHeadApiManager = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/customer_head/by_manager?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (customerNameForApi) {
      queryParams.push(`customer_name=${customerNameForApi}`);
    }
    if (customerStatus) {
      queryParams.push(`customer_status=${customerStatus}`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      // setCustomerHeadList(data)
      setCurrentData(data);
    } else {
      setLoading(false);
    }
  };

  const getCustomerHeadApiManagerCount = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/customer_head/by_manager_count?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (customerNameForApi) {
      queryParams.push(`customer_name=${customerNameForApi}`);
    }
    if (customerStatus) {
      queryParams.push(`customer_status=${customerStatus}`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      // setCustomerHeadList(data)
      setTotalPages(Math.ceil(data[0].totalCount / 20));
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userDataFromStorage.user_role === "admin") {
      getCustomerHeadApi();
      getCustomerHeadApiCount();
    } else {
      getCustomerHeadApiManager();
      getCustomerHeadApiManagerCount();
    }

    return () => {
      setCustomerEditSuccess(false);
      setLoading(false);
    };
  }, [currentPage, customerEditSuccess]);

  useEffect(() => {
    getUsersListHandler();
    getAllCustomerList();
    getAllCustomerNickname();
    getAllAgentNames();
  }, []);

  // state to trigger tab selection
  const [tabCount, setTabCount] = useState(0);

  // tab color change on selection
  useEffect(() => {
    if (tabCount === 0) {
      const el1 = document.getElementById("tab1btn");
      const el2 = document.getElementById("tab2btn");
      el1.style.backgroundColor = "white";
      el2.style.backgroundColor = "transparent";
    } else {
      const el1 = document.getElementById("tab1btn");
      const el2 = document.getElementById("tab2btn");
      el2.style.backgroundColor = "white";
      el1.style.backgroundColor = "transparent";
    }
  }, [tabCount]);

  const customerIdCheckHandler = () => {
    navigate("/customers/detail_id");
  };

  const customerPicHandler = async (e) => {
    e.preventDefault();
    let file = e.target.files[0];
    let formData = new FormData();
    formData.append("image", file);
    setImageLoading(true);

    const { data } = await axios.post(`${API_HOST}/api/upload/`, formData);

    if (data) {
      setImageLoading(false);
      if (data.message) {
        toast.error(data.message);
      } else {
        toast.success("Image Uploaded Successfully !!!");
        setModalData((prevState) => ({
          ...prevState,
          photo: data,
        }));
      }
    }
  };

  const handleCustomerEdit = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/customer_head/update_customer_detail`;

    const { data } = await axios.post(apiUrl, modalData, config);
    if (data.message === "Customer Details Updated Successfully !!!") {
      setLoading(false);
      setCustomerEditSuccess(true);
      setOpenEditModalHandler(false);
      setModalData({
        customer_name: "",
        customer_id: "",
        photo: "",
        id_number: 0,
        mobile_number: "",
        phone_2: "",
        phone_3: "",
        phone_4: "",
        customer_number: "",
      });
    } else {
      setLoading(false);
    }
  };

  const handleNicknameHandler = async () => {
    if (nicknameNew && agentLinkedToNickname) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      const payload = {
        nickname: nicknameNew,
        id_number: nicknameModalData.id_number,
        agent: agentLinkedToNickname,
      };

      const { data } = await axios.post(
        `${API_HOST}/api/customer_head/add_customer_nickname`,
        payload,
        config
      );

      if (data.customer) {
        toast.success("nickname added successfully!!!");
        setNicknameModalData({
          id_number: "",
        });
        setNicknameNew("");
        setNicknameModal(false);
      } else {
        toast.warn(data.message);
      }
    } else {
      toast.warn("Please provide a nickname");
    }
  };

  useEffect(() => {
    if (nicknameModal === true) {
      setOpenEditModalHandler(false);
    }
  }, [nicknameModal]);

  useEffect(() => {
    if (nicknameForApi || customerNameForApi || customerStatus) {
      if (userDataFromStorage.user_role === "admin") {
        getCustomerHeadApi();
      } else {
        getCustomerHeadApiManager();
      }
    }
  }, [nicknameForApi, customerNameForApi, customerStatus]);

  const customFilter = (option, inputValue) => {
    const normalizedInput = inputValue.toLowerCase();
    const normalizedOption = option.toLowerCase();

    // Check if the option exactly matches the input
    if (normalizedOption === normalizedInput) {
      return 0; // Exact match should be on top
    }

    // Check if the option starts with the input
    if (normalizedOption.startsWith(normalizedInput)) {
      return 1;
    }

    // Use default filter for other cases
    return option.indexOf(inputValue.toLowerCase());
  };

  const handleInputChange = useCallback((e) => {
    setCustomerNameContain(e.target.value);
  }, []);

  const handleCustomerNicknameChange = useCallback((e) => {
    setCustomerNickname(e.target.value);
  }, []);

  const filteredOptions = useMemo(() => {
    if (customerNameContain && !selectedCustomerName) {
      const searchTerm = customerNameContain.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      customerOptions.forEach((option) => {
        if (
          option.customer_name &&
          option.customer_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.customer_name.toLowerCase().startsWith(searchTerm)",
            option.customer_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here customer_name");
      setCustomerNameForApi(selectedCustomerName);
      setSelectedCustomerName("");
      return [];
    }
  }, [customerNameContain]);

  const filteredNicknameOptions = useMemo(() => {
    if (customerNickname && !selectedCustomerNickname) {
      const searchTerm = customerNickname.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      customerNicknameList.forEach((option) => {
        if (
          option.nickname &&
          option.nickname.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.nickname.toLowerCase().startsWith(searchTerm)",
            option.nickname.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.nickname.localeCompare(b.nickname, undefined, {
          sensitivity: "base",
        })
      );

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here nickname");
      setNicknameForApi(selectedCustomerNickname);
      setSelectedCustomerNickname("");
      return [];
    }
  }, [customerNickname]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50"
      }>
      {loading ? (
        <Loader />
      ) : (
        <>
          <p className="text-gray-800 text-[1.3rem] md:text-[1.8rem] tracking-wider">
            Customer Overview
          </p>

          {/* custom tab and tab panels */}
          <div className="mt-[2%]">
            <button
              id="tab1btn"
              onClick={() => setTabCount(0)}
              className="md:p-[1rem] p-[0.6rem]">
              By Customer
            </button>
            <button
              id="tab2btn"
              onClick={() => setTabCount(1)}
              className="md:p-[1rem] p-[0.6rem]">
              By Nickname
            </button>
          </div>

          {/* panel based on selected tab*/}
          <div className="bg-white p-[1rem] ">
            {tabCount === 0 ? (
              <>
                <div className="md:flex justify-start items-center">
                  <p className="md:w-[25rem]">Customer Name Contains</p>

                  {/* <Autocomplete
                    // isOptionEqualToValue={(option, value) =>
                    //   option.customer_name === value.customer_name
                    // }
                    className="outline-none mt-2 md:mt-0 w-[100%] md:w-auto  p-[0.3rem] md:flex-grow"
                    options={customerOptions}
                    // autoComplete
                    getOptionLabel={(option) => option.customer_name}
                    // filterOptions={filterOptions}
                    renderInput={(params) => (
                      <TextField {...params} label="Customer Name" />
                    )}
                  /> */}
                  <div className="relative  md:flex-grow w-[100%] md:w-auto">
                    <input
                      type="text"
                      value={customerNameContain}
                      onInput={(e) => {
                        console.log("e.target::::::", e.target.value);
                        handleInputChange(e);
                      }}
                      className="outline-none  border border-gray-300 rounded-lg  w-[100%]   p-[0.5rem] "
                    />
                    {filteredOptions.length > 0 && (
                      <div className="absolute 2xl:top-[4rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10">
                        {filteredOptions.map((option, index) => (
                          <div
                            className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                            onClick={() => {
                              setSelectedCustomerName(option.customer_name);
                              setCustomerNameContain(option.customer_name);
                            }}
                            key={index}>
                            {option.customer_name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="md:flex justify-start items-center mt-6">
                  <p className="md:w-[25rem]">Customer Status</p>
                  <div className="mt-2 md:mt-0 px-2 md:px-0  ">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={customerStatus}
                        name="radio-buttons-group"
                        onChange={(e) => setCustomerStatus(e.target.value)}
                        row>
                        <FormControlLabel
                          value={"Good"}
                          control={<Radio />}
                          label="Good"
                        />
                        <FormControlLabel
                          value={"Bad"}
                          control={<Radio />}
                          label="Bad"
                        />
                        <FormControlLabel
                          value={"Block"}
                          control={<Radio />}
                          label="Block"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>

                <div className="flex justify-start items-center space-x-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => {
                      setCustomerNameContain("");
                      setCustomerStatus("");
                      setSelectedCustomerName("");
                    }}
                    id="overviewButton"
                    className="flex justify-center items-center   rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white ">
                    <FaUndo className="hidden md:block" />
                    <p>Reset Search Fields</p>
                  </button>
                  <button
                    onClick={() => {
                      if (userDataFromStorage.user_role === "admin") {
                        getCustomerHeadApi();
                      } else {
                        getCustomerHeadApiManager();
                      }
                    }}
                    style={{ backgroundColor: coloredTheme }}
                    id="overViewButton2"
                    className="flex justify-center   items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
                    <FiSearch className="hidden md:block" />
                    <p>Search</p>
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="md:flex justify-start items-center">
                  <p className="md:w-[25rem]">Customer Nickname</p>
                  {/* <input
                    value={customerNickname}
                    onChange={(e) => setCustomerNickname(e.target.value)}
                    type="text"
                    className=""
                  /> */}

                  <div className="relative  md:flex-grow w-[100%] md:w-auto">
                    <input
                      type="text"
                      value={customerNickname}
                      onInput={(e) => {
                        console.log("e.target::::::", e.target.value);
                        handleCustomerNicknameChange(e);
                      }}
                      className="outline-none  border border-gray-300 rounded-lg  w-[100%]   p-[0.5rem] "
                    />
                    {filteredNicknameOptions.length > 0 && (
                      <div className="absolute 2xl:top-[4rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10">
                        {filteredNicknameOptions.map((option, index) => {
                          console.log(
                            "filteredNicknameOptions",
                            filteredNicknameOptions
                          );

                          return (
                            <div
                              className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                              onClick={() => {
                                setSelectedCustomerNickname(option.nickname);
                                setCustomerNickname(option.nickname);
                              }}
                              key={index}>
                              {option.nickname}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <div className="md:flex justify-start items-center mt-6">
                  <p className="md:w-[25rem]">Customer Status</p>
                  <div className="mt-2 md:mt-0 px-2 md:px-0  ">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={customerStatus}
                        name="radio-buttons-group"
                        onChange={(e) => setCustomerStatus(e.target.value)}
                        row>
                        <FormControlLabel
                          value={"Good"}
                          control={<Radio />}
                          label="Good"
                        />
                        <FormControlLabel
                          value={"Bad"}
                          control={<Radio />}
                          label="Bad"
                        />
                        <FormControlLabel
                          value={"Block"}
                          control={<Radio />}
                          label="Block"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <div className="flex justify-start items-center space-x-4">
                  <button
                    onClick={() => {
                      setCustomerNickname("");
                      setCustomerStatus("");
                      setSelectedCustomerNickname("");
                    }}
                    style={{ backgroundColor: coloredTheme }}
                    id="overviewButton"
                    className="flex justify-center items-center   rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white ">
                    <FaUndo className="hidden md:block" />
                    <p>Reset Search Fields</p>
                  </button>
                  <button
                    onClick={() => {
                      if (userDataFromStorage.user_role === "admin") {
                        getCustomerHeadApi();
                      } else {
                        getCustomerHeadApiManager();
                      }
                    }}
                    style={{ backgroundColor: coloredTheme }}
                    id="overViewButton2"
                    className="flex justify-center   items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
                    <FiSearch className="hidden md:block" />
                    <p>Search</p>
                  </button>
                </div>
              </>
            )}
          </div>

          {/* panel data based on selected tab */}
          <div className="mt-8 overflow-scroll w-[100%]">
            <div className="w-[100%] overflow-scroll">
              <table className="xl:w-[100%] lg:w-[130%] md:w-[180%] w-[450%]">
                <thead className="h-[5vh] ">
                  <tr className="border border-gray-600">
                    <th
                      style={{ backgroundColor: coloredTheme }}
                      className="text-center   p-[0.2rem]   text-white">
                      Photo
                    </th>
                    <th
                      style={{ backgroundColor: coloredTheme }}
                      className="text-center  text-white p-[0.2rem]  ">
                      Customer ID
                    </th>
                    <th
                      style={{ backgroundColor: coloredTheme }}
                      className="text-center  text-white p-[0.2rem]  ">
                      Customer Name
                    </th>
                    {/* <th style={{ backgroundColor: coloredTheme }} className='text-center  text-white p-[0.2rem]  '>Id-No</th> */}
                    <th
                      style={{ backgroundColor: coloredTheme }}
                      className="text-center  text-white p-[0.2rem]  ">
                      Max Loan Amount
                    </th>
                    <th
                      style={{ backgroundColor: coloredTheme }}
                      className="text-center  text-white p-[0.2rem]  "></th>
                    <th
                      style={{ backgroundColor: coloredTheme }}
                      className="text-center  text-white border-r p-[0.2rem]  "></th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length
                    ? currentData.map((x, index) => {
                        if (userDataFromStorage.user_role === "admin") {
                          return (
                            <tr
                              key={index}
                              className="border-b border-gray-700 bg-white">
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                <img
                                  src={x._id?.photo}
                                  style={{ width: "60px", height: "60px" }}
                                  alt=""
                                />
                              </td>
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                {x._id?.customer_id}
                              </td>
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                {x._id.customer_name}
                              </td>
                              {/* <td className='text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]'>{x.id_number}</td> */}
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                {x._id.max_loan_amount}
                              </td>
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                <table className="w-[100%] ">
                                  <thead className="border-b h-[5vh]">
                                    <th
                                      style={{ backgroundColor: coloredTheme }}
                                      className="text-center border-b border-r  border-gray-700  w-1/3 text-white tracking-wider  ">
                                      Nickname
                                    </th>
                                    <th
                                      style={{ backgroundColor: coloredTheme }}
                                      className="text-center border-b border-gray-700  border-r  text-white tracking-wider ">
                                      Agent
                                    </th>
                                    <th
                                      style={{ backgroundColor: coloredTheme }}
                                      className="text-center border-b  border-gray-700  text-white tracking-wider ">
                                      Phone No's
                                    </th>
                                  </thead>
                                  <tbody>
                                    {x.customerDetail.map((customer, idx) => {
                                      let agentName = agentNameList.find(
                                        (user) =>
                                          user.agent_id === customer.agent
                                      );
                                      console.log("agentName", agentName);

                                      if (agentName) {
                                        return (
                                          <tr
                                            onClick={() => {
                                              setOpenEditModalHandler(true);
                                              setModalData({
                                                customer_name:
                                                  x._id.customer_name,
                                                customer_id: x._id?.customer_id,
                                                photo: x._id?.photo,
                                                id_number: customer.id_number,
                                                mobile_number:
                                                  customer.mobile_number,
                                                phone_2: customer.phone_2,
                                                phone_3: customer.phone_3,
                                                phone_4: customer.phone_4,
                                                customer_number:
                                                  x._id.customer_number,
                                                agent: agentName.agent_name,
                                                nickname: customer.nickname,
                                              });
                                            }}
                                            key={idx}
                                            className="border-b border-gray-700 bg-white hover:bg-cyan-100 transition duration-[0.3s] cursor-pointer">
                                            <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                              {customer.nickname}
                                            </td>
                                            <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                              {agentName.agent_name}
                                            </td>
                                            <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                              <p>{customer.mobile_number}</p>
                                              <p>{customer.phone_2}</p>
                                              <p>{customer.phone_3}</p>
                                              <p>{customer.phone_4}</p>
                                            </td>
                                          </tr>
                                        );
                                      }
                                    })}
                                  </tbody>
                                </table>
                              </td>
                              <td
                                onClick={(e) => {
                                  e.preventDefault();
                                  // setNicknameModal(true);
                                  // setNicknameModalData({
                                  //   id_number: x.id_number,
                                  // });
                                  navigate(
                                    `/customers/add_nickname?customerHeadId=${x._id.id_number}`
                                  );
                                }}
                                className="text-start border-l border-t border-r border-gray-700 rounded-lg p-[0.2rem]">
                                <button
                                  style={{ backgroundColor: coloredTheme }}
                                  className="flex  items-center justify-center space-x-2 px-[1rem]  py-[0.5rem] rounded text-white">
                                  <RiSave2Fill />
                                  <p>Add Nickname</p>
                                </button>
                              </td>
                            </tr>
                          );
                        } else if (
                          userDataFromStorage.user_role === "manager"
                        ) {
                          return (
                            <tr
                              key={index}
                              className="border-b border-gray-700 bg-white ">
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                <img
                                  src={x._id?.photo}
                                  style={{ width: "60px", height: "60px" }}
                                  alt=""
                                />
                              </td>
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                {x._id?.customer_id}
                              </td>
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                {x._id.customer_name}
                              </td>
                              {/* <td className='text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]'>{x.id_number}</td> */}
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                {x._id.max_loan_amount}
                              </td>
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                <table className="w-[100%] ">
                                  <thead className="border-b h-[5vh]">
                                    <th
                                      style={{ backgroundColor: coloredTheme }}
                                      className="text-center border-b border-r  border-gray-700  w-1/3 text-white tracking-wider  ">
                                      Nickname
                                    </th>
                                    <th
                                      style={{ backgroundColor: coloredTheme }}
                                      className="text-center border-b border-gray-700  border-r  text-white tracking-wider ">
                                      Agent
                                    </th>
                                    <th
                                      style={{ backgroundColor: coloredTheme }}
                                      className="text-center border-b  border-gray-700  text-white tracking-wider ">
                                      Phone No's
                                    </th>
                                  </thead>
                                  <tbody>
                                    {x.customerDetail.map((customer, idx) => {
                                      let agentName = agentNameList.find(
                                        (user) =>
                                          user.agent_id === customer.agent
                                      );
                                      console.log("agentName", agentName);

                                      if (agentName) {
                                        return (
                                          <tr
                                            onClick={() => {
                                              setOpenEditModalHandler(true);
                                              setModalData({
                                                customer_name:
                                                  x._id.customer_name,
                                                customer_id: x._id?.customer_id,
                                                photo: x._id?.photo,
                                                id_number: customer.id_number,
                                                mobile_number:
                                                  customer.mobile_number,
                                                phone_2: customer.phone_2,
                                                phone_3: customer.phone_3,
                                                phone_4: customer.phone_4,
                                                customer_number:
                                                  x._id.customer_number,
                                                agent: agentName.agent_name,
                                                nickname: customer.nickname,
                                              });
                                            }}
                                            key={idx}
                                            className="border-b border-gray-700 bg-white hover:bg-cyan-100 transition duration-[0.3s] cursor-pointer">
                                            <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                              {customer.nickname}
                                            </td>
                                            <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                              {agentName.agent_name}
                                            </td>
                                            <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                              <p>{customer.mobile_number}</p>
                                              <p>{customer.phone_2}</p>
                                              <p>{customer.phone_3}</p>
                                              <p>{customer.phone_4}</p>
                                            </td>
                                          </tr>
                                        );
                                      }
                                    })}
                                  </tbody>
                                </table>
                              </td>
                              <td className="text-start border-l border-t border-r border-gray-700 rounded-lg p-[0.2rem]">
                                <button
                                  style={{ backgroundColor: coloredTheme }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigate(
                                      `/customers/add_nickname?customerHeadId=${x._id.id_number}`
                                    );
                                  }}
                                  className="flex  items-center justify-center space-x-2 px-[1rem]  py-[0.5rem] rounded text-white">
                                  <RiSave2Fill />
                                  <p>Add Nickname</p>
                                </button>
                              </td>
                            </tr>
                          );
                        } else {
                          return (
                            <tr
                              key={index}
                              className="border-b border-gray-700 bg-white">
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                <img
                                  src={x._id?.photo}
                                  style={{ width: "60px", height: "60px" }}
                                  alt=""
                                />
                              </td>
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                {x._id?.customer_id}
                              </td>
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                {x._id.customer_name}
                              </td>
                              {/* <td className='text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]'>{x.id_number}</td> */}
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                {x._id.max_loan_amount}
                              </td>
                              <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                <table className="w-[100%] ">
                                  <thead className="border-b h-[5vh]">
                                    <th
                                      style={{ backgroundColor: coloredTheme }}
                                      className="text-center border-b border-r  border-gray-700  w-1/3 text-white tracking-wider  ">
                                      Nickname
                                    </th>
                                    <th
                                      style={{ backgroundColor: coloredTheme }}
                                      className="text-center border-b border-gray-700  border-r  text-white tracking-wider ">
                                      Agent
                                    </th>
                                    <th
                                      style={{ backgroundColor: coloredTheme }}
                                      className="text-center border-b  border-gray-700  text-white tracking-wider ">
                                      Phone No's
                                    </th>
                                  </thead>
                                  <tbody>
                                    {x.customerDetail.map((customer, idx) => {
                                      let agentName = agentNameList.find(
                                        (user) =>
                                          user.agent_id === customer.agent
                                      );
                                      console.log("agentName", agentName);

                                      if (agentName) {
                                        return (
                                          <tr
                                            onClick={() => {
                                              setOpenEditModalHandler(true);
                                              setModalData({
                                                customer_name:
                                                  x._id.customer_name,
                                                customer_id: x._id?.customer_id,
                                                photo: x._id?.photo,
                                                id_number: customer.id_number,
                                                mobile_number:
                                                  customer.mobile_number,
                                                phone_2: customer.phone_2,
                                                phone_3: customer.phone_3,
                                                phone_4: customer.phone_4,
                                                customer_number:
                                                  x._id.customer_number,
                                                // agent: agentName.agent_name,
                                                // nickname: customer.nickname,
                                              });
                                            }}
                                            key={idx}
                                            className="border-b border-gray-700 bg-white hover:bg-cyan-100 transition duration-[0.3s] cursor-pointer">
                                            <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                              {customer.nickname}
                                            </td>
                                            <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                              {agentName.agent_name}
                                            </td>
                                            <td className="text-center border-l border-t border-gray-700 rounded-lg p-[0.2rem]">
                                              <p>{customer.mobile_number}</p>
                                              <p>{customer.phone_2}</p>
                                              <p>{customer.phone_3}</p>
                                              <p>{customer.phone_4}</p>
                                            </td>
                                          </tr>
                                        );
                                      }
                                    })}
                                  </tbody>
                                </table>
                              </td>
                              {/* <td className='text-start border-l border-t border-r border-gray-700 rounded-lg p-[0.2rem]'>
                          <button style={{ backgroundColor: coloredTheme }} className='flex  items-center justify-center space-x-2 px-[1rem]  py-[0.5rem] rounded text-white'>
                            <RiSave2Fill />
                            <p>Add Nickname</p>
                          </button>
                        </td> */}
                            </tr>
                          );
                        }
                      })
                    : ""}
                </tbody>
              </table>
            </div>

            <div className=" flex justify-end items-center mt-[2%] px-[0.8rem]">
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={(event, newPage) => setCurrentPage(newPage)}
                  variant="outlined"
                  shape="rounded"
                />
              </Stack>
            </div>

            <div className="flex justify-start items-center space-x-4 mt-8 mb-8">
              <button
                style={{ backgroundColor: coloredTheme }}
                id="customerbtn"
                onClick={customerIdCheckHandler}
                className="flex justify-center items-center   space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded   hover:shadow-2xl hover:shadow-black">
                <RiSave2Fill />
                <p>Add Customer</p>
              </button>
              <button
                onClick={() => navigate("/home")}
                style={{ backgroundColor: coloredTheme }}
                id="cancelCustomer"
                className="flex   justify-center items-center space-x-2  text-green-50 px-[1rem] py-[0.5rem] rounded  hover:shadow-2xl hover:shadow-black ">
                <IoExitOutline />
                <p>Exit</p>
              </button>
            </div>
          </div>
        </>
      )}

      <Modal
        open={openEditModalHandler}
        onClose={() => setOpenEditModalHandler(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="lg:w-[50%] md:w-[50%] w-[95%] rounded-lg bg-white absolute top-[10%]  mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Edit Customer Data</p>
              </div>
              <Divider />
              <div className="p-[0.5rem]">
                {userDataFromStorage.user_role === "admin" ||
                userDataFromStorage.user_role === "manager" ? (
                  <div className="grid grid-cols-4 mt-2">
                    <label
                      htmlFor="CustomerName"
                      className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">Customer Name</span>
                    </label>
                    <input
                      onChange={(e) =>
                        setModalData((prevState) => ({
                          ...prevState,
                          customer_name: e.target.value,
                        }))
                      }
                      disabled={true}
                      value={modalData?.customer_name}
                      type="text"
                      id="CustomerName"
                      className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                      placeholder="Enter Customer Name"
                    />
                  </div>
                ) : (
                  ""
                )}

                {userDataFromStorage.user_role === "admin" ||
                userDataFromStorage.user_role === "manager" ? (
                  <div className="grid grid-cols-4 mt-2">
                    <label
                      htmlFor="customerId"
                      className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">Customer ID</span>
                    </label>
                    <input
                      onChange={(e) =>
                        setModalData((prevState) => ({
                          ...prevState,
                          customer_id: e.target.value,
                        }))
                      }
                      disabled={true}
                      value={modalData?.customer_id}
                      type="text"
                      id="customerId"
                      className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                      placeholder="Enter Customer Id"
                    />
                  </div>
                ) : (
                  ""
                )}

                {userDataFromStorage.user_role === "admin" ||
                userDataFromStorage.user_role === "manager" ? (
                  <div className="grid grid-cols-4 mt-2">
                    <label
                      htmlFor="customerId"
                      className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">Agent Name</span>
                    </label>
                    <input
                      disabled={true}
                      value={modalData?.agent}
                      type="text"
                      id="agentName"
                      className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                      placeholder="Enter Customer Id"
                    />
                  </div>
                ) : (
                  ""
                )}

                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="mobile"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Mobile Number</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setModalData((prevState) => ({
                        ...prevState,
                        mobile_number: e.target.value,
                      }))
                    }
                    value={modalData?.mobile_number}
                    type="number"
                    id="mobile"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter Your Mobile Number !!!"
                  />
                </div>

                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="CustomerName"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Customer Nickname</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setModalData((prevState) => ({
                        ...prevState,
                        nickname: e.target.value,
                        // agent_id: userDataFromStorage.employee_number,
                      }))
                    }
                    value={modalData?.nickname}
                    disable={
                      userDataFromStorage.user_role === "admin" ||
                      userDataFromStorage.user_role === "manager"
                        ? false
                        : true
                    }
                    type="text"
                    id="CustomerName"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter Customer Nickname"
                  />
                </div>

                {userDataFromStorage.user_role === "admin" ||
                userDataFromStorage.user_role === "manager" ? (
                  <>
                    <div className="grid grid-cols-4 mt-2">
                      <label
                        htmlFor="phone2"
                        className="flex justify-start items-center col-span-1 space-x-1">
                        <span className="text-gray-700">Phone 2</span>
                      </label>
                      <input
                        onChange={(e) =>
                          setModalData((prevState) => ({
                            ...prevState,
                            phone_2: e.target.value,
                          }))
                        }
                        value={modalData?.phone_2}
                        type="number"
                        id="phone2"
                        className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                        placeholder="Enter Your Mobile Number !!!"
                      />
                    </div>

                    <div className="grid grid-cols-4 mt-2">
                      <label
                        htmlFor="phone3"
                        className="flex justify-start items-center col-span-1 space-x-1">
                        <span className="text-gray-700">Phone 3</span>
                      </label>
                      <input
                        onChange={(e) =>
                          setModalData((prevState) => ({
                            ...prevState,
                            phone_3: e.target.value,
                          }))
                        }
                        value={modalData?.phone_3}
                        type="number"
                        id="phone3"
                        className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                        placeholder="Enter Your Mobile Number !!!"
                      />
                    </div>

                    <div className="grid grid-cols-4 mt-2">
                      <label
                        htmlFor="phone4"
                        className="flex justify-start items-center col-span-1 space-x-1">
                        <span className="text-gray-700">Phone 4</span>
                      </label>
                      <input
                        onChange={(e) =>
                          setModalData((prevState) => ({
                            ...prevState,
                            phone_4: e.target.value,
                          }))
                        }
                        value={modalData?.phone_4}
                        type="number"
                        id="phone4"
                        className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                        placeholder="Enter Your Mobile Number !!!"
                      />
                    </div>

                    <div className="flex justify-center items-center mt-6 ">
                      {/*  */}
                      {imageLoading ? (
                        <div
                          class="w-12 h-12 rounded-full animate-spin
                                      border-2 border-solid border-blue-500 border-t-transparent"></div>
                      ) : (
                        <>
                          <label
                            htmlFor="customerPic"
                            className="border col-span-3 group-hover:shadow-2xl flex justify-center items-center rounded-lg px-[2rem] bg-sky-50 group-hover:bg-sky-200 transition duration-[0.6s]   py-[0.5rem] border-[#3b82f6] text-lg text-[#57534e]  ">
                            {" "}
                            <BsCameraFill className="text-[#14b8a6] text-[1.5rem] mr-2 group-hover:text-[#7c3aed] transition duration-[0.6s]" />
                            Customer Photo
                          </label>
                          <input
                            onChange={(e) => customerPicHandler(e)}
                            type="file"
                            id="customerPic"
                            style={{ display: "none" }}
                            placeholder="Enter a Max Loan Amount"
                          />
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  ""
                )}

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => setOpenEditModalHandler(false)}
                    className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded   hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => handleCustomerEdit()}
                    className="flex justify-center items-center space-x-2 text-white px-[1rem] py-[0.5rem] rounded   hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      {/* CUSTOMER NICKNAME CREATION MODAL */}
      <Modal
        open={nicknameModal}
        onClose={() => setNicknameModal(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="lg:w-[50%] md:w-[50%] w-[95%] rounded-lg bg-white absolute top-[10%]  mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Add Customer Nickname</p>
              </div>
              <Divider />
              <div className="p-[0.5rem]">
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="CustomerName"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Customer Nickname</span>
                  </label>
                  <input
                    onChange={(e) => setNicknameNew(e.target.value)}
                    value={nicknameNew}
                    type="text"
                    id="CustomerName"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter Customer Nickname"
                  />
                </div>

                <div className="grid grid-cols-4 mt-2 ">
                  <p className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Assign Agent : </span>
                  </p>

                  <select
                    onChange={(e) => setAgentLinkedToNickname(e.target.value)}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3">
                    <option value={"none"}>Select An Agent/Snr Agent</option>
                    {usersList.length ? (
                      usersList.map((x, index) => (
                        <option key={index} value={x.employee_number}>
                          {x.last_name}
                        </option>
                      ))
                    ) : (
                      <>
                        <option value={"manager1"}>Manager 1</option>
                        <option value={"manager2"}>Manager 2</option>
                        <option value={"manager3"}>Manager 3</option>
                        <option value={"manager4"}>Manager 4</option>
                      </>
                    )}
                  </select>
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => setNicknameModal(false)}
                    className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded   hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => handleNicknameHandler()}
                    className="flex justify-center items-center space-x-2 text-white px-[1rem] py-[0.5rem] rounded   hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default Customers;
